export const NEW_ROOM_PAGE = 'new-room';
export const ROOMS_PAGE = 'rooms';
export const ROOM_PAGE = 'room';
export const MODULE_ROOM_PAGE = 'module-room';
export const ADD_ROOM_ENTRY_PAGE = 'add-room-entry';
export const ADD_MODULE_ROOM_ENTRY_PAGE = 'add-module-room-entry';
export const UPDATE_ROOM_ENTRY_PAGE = 'update-room-entry';
